import { keyBy } from 'lodash';

export function evaluationList(state) {
  return state.evaluationList;
}

export function evaluations(state) {
  return keyBy(state.evaluationList, evaluation => evaluation.id);
}

export function evaluationFilters(state) {
  return state.evaluationFilters;
}

export function evaluationSubjectMap(state) {
  return state.evaluationSubjectMap;
}

export function evaluationCriteria(state) {
  return state.evaluationCriteria;
}

export function evaluationOrderBy(state) {
  return state.evaluationOrderBy;
}

export function classEvaluationDomains(state) {
  return state.classEvaluationDomains;
}

export function selectedClassEvaluationDomainIds(state) {
  return state.selectedClassEvaluationDomainIds;
}



// WEBPACK FOOTER //
// ./src/app/evaluations/store/getters.js